'use client';
var classes = {"datePickerRoot":"m_765a40cf","presetsList":"m_d6a681e1","presetButton":"m_acd30b22"};

export { classes as default };
//# sourceMappingURL=DatePicker.module.css.mjs.map
